import React from "react";

/**
 * 아카이브 > 회고록 > 결과 없을 때
 */

const SearchEmpty = () => {
    return (
        <div className="empty">
            <p>찾으시는 검색결과가 없습니다.</p>
        </div>
    );
};

export default SearchEmpty;
